var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6794 3.27685C12.9226 3.27685 13.125 3.47873 13.125 3.7356V3.9731C13.125 4.22372 12.9226 4.43184 12.6794 4.43184H2.32116C2.07741 4.43184 1.875 4.22372 1.875 3.9731V3.7356C1.875 3.47873 2.07741 3.27685 2.32116 3.27685H4.14348C4.51366 3.27685 4.83581 3.01373 4.91909 2.64249L5.01452 2.21624C5.16284 1.63562 5.65093 1.25 6.20954 1.25H8.79046C9.34299 1.25 9.83656 1.63562 9.9794 2.18562L10.0815 2.64186C10.1642 3.01373 10.4863 3.27685 10.8571 3.27685H12.6794ZM11.7547 11.9589C11.945 10.1857 12.2781 5.97329 12.2781 5.93079C12.2902 5.80204 12.2483 5.68016 12.165 5.58204C12.0757 5.49017 11.9626 5.43579 11.838 5.43579H3.16891C3.0437 5.43579 2.92456 5.49017 2.84189 5.58204C2.75801 5.68016 2.71668 5.80204 2.72275 5.93079C2.72387 5.9386 2.73582 6.08698 2.75581 6.33505C2.84458 7.43709 3.09182 10.5064 3.25158 11.9589C3.36464 13.0288 4.0667 13.7013 5.08362 13.7257C5.86835 13.7438 6.67679 13.7501 7.50346 13.7501C8.28211 13.7501 9.07291 13.7438 9.88196 13.7257C10.9341 13.7076 11.6356 13.047 11.7547 11.9589Z",
    fill: "#ACABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.50b20c1e6acfa775b9491d029ce1b57c.svg";
export { ForwardRef as ReactComponent };